import { Component, ElementRef, ViewChild } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { AdminService } from './admin.service';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CurrencyDto } from '../models/CurrencyDto';

@Component({
  selector: 'rl-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent {

  @ViewChild('spreadsheet') container: ElementRef;

  users: any[];
  currencyPairs: Array<CurrencyDto>;
  sheet = true;


  constructor(private readonly adminService: AdminService,
              private readonly modalService: BsModalService,
              private readonly snackBar: MatSnackBar,
              private readonly authenticationService: AuthenticationService,
              private readonly router: Router) {
  }

  logout() {
    this.authenticationService.logout().subscribe(() => {
      localStorage.removeItem('currentUser');
      this.router.navigateByUrl('login');
    });
  }
}
